var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-sheetmask",class:{ 'is-open': _vm.open },on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('close')}}},[_c('div',{staticClass:"mc-sheet"},[_c('div',{staticClass:"mc-grab"}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }